var Le = Object.defineProperty, We = Object.defineProperties;
var Pe = Object.getOwnPropertyDescriptors;
var he = Object.getOwnPropertySymbols;
var Fe = Object.prototype.hasOwnProperty, He = Object.prototype.propertyIsEnumerable;
var P = (a, t, n) => t in a ? Le(a, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : a[t] = n, F = (a, t) => {
  for (var n in t || (t = {}))
    Fe.call(t, n) && P(a, n, t[n]);
  if (he)
    for (var n of he(t))
      He.call(t, n) && P(a, n, t[n]);
  return a;
}, H = (a, t) => We(a, Pe(t));
var C = (a, t, n) => P(a, typeof t != "symbol" ? t + "" : t, n);
var v = (a, t, n) => new Promise((d, i) => {
  var r = (l) => {
    try {
      s(n.next(l));
    } catch (o) {
      i(o);
    }
  }, e = (l) => {
    try {
      s(n.throw(l));
    } catch (o) {
      i(o);
    }
  }, s = (l) => l.done ? d(l.value) : Promise.resolve(l.value).then(r, e);
  s((n = n.apply(a, t)).next());
});
var A, R;
(function() {
  try {
    var a = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {}, t = new a.Error().stack;
    t && (a._sentryDebugIds = a._sentryDebugIds || {}, a._sentryDebugIds[t] = "59d0056a-ed1a-44c7-b966-e10f8f6691b6", a._sentryDebugIdIdentifier = "sentry-dbid-59d0056a-ed1a-44c7-b966-e10f8f6691b6");
  } catch (n) {
  }
})(), (typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {}).SENTRY_RELEASE = { id: "0c04034350c2641e6bf0acaf1a6d74f1c93bb5ef" }, function(a) {
  a.Sidebar = "sidebar", a.Searchbar = "searchbar";
}(A || (A = {})), A.Sidebar, A.Searchbar;
class de extends Error {
  constructor(n, d) {
    super(n, d);
    C(this, "cause");
    this.name = "BrainfishWidgetError", this.cause = d == null ? void 0 : d.cause, Error.captureStackTrace && Error.captureStackTrace(this, de), this.cause instanceof Error && this.cause.stack && (this.stack = this.stack + `
Caused by: ` + this.cause.stack);
  }
  toJSON() {
    return { name: this.name, message: this.message, stack: this.stack, cause: this.cause instanceof Error ? { name: this.cause.name, message: this.cause.message, stack: this.cause.stack } : this.cause };
  }
}
(function(a) {
  a.LINK = "link", a.CALLBACK = "callback", a.EMAIL = "email", a.PHONE = "phone";
})(R || (R = {}));
const _ = (a, t, n, d) => {
  let i = n, r = {};
  if (t instanceof Error) try {
    r = JSON.parse(t.message), i += ` - ${r.message || t.message}`;
  } catch (e) {
    i += ` - ${t.message}`;
  }
  else i += ` - ${String(t)}`;
  ((e, s, l) => {
    if (!navigator || navigator.userAgent.toLowerCase().includes("headless")) return;
    const o = s.toJSON();
    fetch(`${e || "https://app.brainfi.sh"}/api/trackError.widget.create`, { method: "POST", headers: { "Content-Type": "application/json", "api-key": l }, body: JSON.stringify({ error: `WebWidgetVersion: 1.10.1. ${s.message}`, stack: s.stack, cause: { message: o.message, stack: o.stack, cause: o.cause } }) });
  })(a, new de(i, { cause: r }), d);
}, $e = (a) => v(void 0, null, function* () {
  let { widgetKey: t, apiHost: n } = a;
  return function(d, i, r) {
    return v(this, null, function* () {
      let e, s = 0;
      for (; s < 3; ) try {
        const l = yield fetch(`${d}${i}`, { method: "POST", headers: { "Content-Type": "application/json", "api-key": r } });
        if (!l.ok) throw new Error(`API call failed with status: ${l.status}`);
        const o = yield l.json();
        if (!o) throw new Error("Error loading config: empty response");
        return o;
      } catch (l) {
        if (e = l, s++, s >= 3) throw _(d, l, "Error fetching config", r), e;
        yield new Promise((o) => setTimeout(o, 500));
      }
    });
  }(n, "/api/searchWidgets.getConfigByKey", t);
}), Ke = (a) => {
  let { config: t, apiKey: n, apiHost: d } = a;
  const i = t.settings || {};
  return ["bodyActionButtons", "footerActionButtons", "nextBestActions"].forEach((r) => {
    i[r] && (i[r] = i[r].map((e) => e.type === R.CALLBACK && e.value ? H(F({}, e), { value: new Function(`return ${e.value}`)() }) : e));
  }), H(F({}, t), { settings: i, apiHost: d, widgetMode: t.widgetType, apiKey: n });
}, le = (a) => (a == null ? void 0 : a.apiHost) || "https://app.brainfi.sh", $ = (() => {
  if (typeof window == "undefined") return;
  const a = window.navigator.userAgent;
  if (!(a.match(/iPad/i) || a.match(/iPhone/i))) return !1;
  const t = a.match(/OS (\d+)_/i);
  return t && parseInt(t[1], 10) <= 14;
})(), ze = (a) => v(void 0, null, function* () {
  let { apiHost: t, widgetKey: n, version: d } = a;
  try {
    const i = `https://cdn.jsdelivr.net/npm/@brainfish-ai/search-widget@${d}/dist/web.js`, r = $ ? i.replace("web.js", "web.umd.js") : i;
    return { widget: yield ((s) => v(void 0, null, function* () {
      return document.getElementById("brainfish-widget") ? window.Brainfish : new Promise((l, o) => {
        const u = document.createElement("script");
        u.id = "brainfish-widget", u.src = s, u.type = $ ? "text/javascript" : "module", u.async = !0, u.crossOrigin = "anonymous", u.onload = () => {
          setTimeout(() => {
            const c = window.Brainfish;
            c ? l(c) : o(new Error("Failed to load Brainfish module"));
          }, 200);
        }, u.onerror = (c) => {
          const f = c, g = { message: `Failed to load script: ${s}`, type: f.type, fileName: f.filename, lineNumber: f.lineno, columnNumber: f.colno, error: f.error ? f.error.toString() : "Unknown error" };
          o(new Error(JSON.stringify(g)));
        }, $ || document.head.appendChild(u);
      });
    }))(r) };
  } catch (i) {
    _(t, i, i.message, n);
  }
}), me = /* @__PURE__ */ new Set(), Re = (a, t) => v(void 0, null, function* () {
  const n = le(a.overrides);
  try {
    if (me.has(a.widgetKey)) return;
    const d = yield ze({ apiHost: n, widgetKey: a.widgetKey, version: t.version || "latest" });
    if (d) {
      const { widget: i } = d, r = Ke({ config: t, apiKey: a.widgetKey, apiHost: n });
      return a.overrides && t.settings && Object.entries(a.overrides).forEach((e) => {
        let [s, l] = e;
        t.settings && s in t.settings && (t.settings[s] = function() {
          let o = arguments.length > 1 ? arguments[1] : void 0;
          const u = new Map((arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : []).map((c) => [c.label, c]));
          return o.forEach((c) => u.set(c.label, c)), Array.from(u.values());
        }(t.settings[s], l));
      }), function(e, s) {
        s.widgetType === A.Searchbar || s.widgetType === "Search" ? e.SearchWidget.initStandard(s) : e.HelpWidget.initPopup(s);
      }(i, r), me.add(a.widgetKey), i;
    }
  } catch (d) {
    _(n, d, d.message, a.widgetKey);
  }
});
let be = !1;
const qe = function(d, i, r) {
  return v(this, arguments, function* (a, t, n) {
    let e = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", s = arguments.length > 4 && arguments[4] !== void 0 && arguments[4], l = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : [], o = arguments.length > 6 ? arguments[6] : void 0;
    if (t || _(n, new Error("Access key is required"), "Access key is required", a), !be) try {
      const u = (() => {
        if (typeof window == "undefined" || typeof navigator == "undefined") return !1;
        const c = navigator, f = window, g = (c.doNotTrack || f.doNotTrack || c.msDoNotTrack || "0").toString().toLowerCase();
        return ["1", "yes", "true"].includes(g);
      })();
      window.BrainfishAnalytics("init", { apiUrl: e, accessKey: t, trackScreenViews: !0, trackAttributes: !u, trackOutgoingLinks: !u, enableRecording: !u && s, recordingBlocklist: l, _allowLocalhostRecording: o }), be = !0, yield ((c, f) => v(this, null, function* () {
        if (document.getElementById("brainfish-analytics")) return window.BrainfishAnalytics;
        const g = document.createElement("script");
        g.id = "brainfish-analytics", g.src = "https://cdn.jsdelivr.net/npm/@brainfish-ai/web-tracker@latest/dist/tracker.js", g.type = "module", g.async = !0, g.crossOrigin = "anonymous", g.onerror = () => {
          _(c, new Error(`Failed to load script: ${g.src}`), `Failed to load script: ${g.src}`, f);
        }, document.head.appendChild(g);
      }))(n, a);
    } catch (u) {
      _(n, u, "Failed to initialize BrainfishAnalytics", a);
    }
  });
};
function S(a, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const d = document.createElement(a);
  return d.className = t, Object.entries(n).forEach((i) => {
    let [r, e] = i;
    d.setAttribute(r, e);
  }), d;
}
const L = "bf-iframe-container", W = "bf-trigger-button";
class y {
  static get isWidgetOpen() {
    return this.isOpen;
  }
  static initialize(t) {
    var n, d;
    let { button: i, icon: r, isButtonHidden: e } = t;
    this.button = i || null, this.icon = r || null, this.isButtonHidden = e || !1, i && i.addEventListener("click", () => this.toggleIframeVisibility()), (n = window.Brainfish) !== null && n !== void 0 && n.HelpWidget && (window.Brainfish.HelpWidget.close = () => this.closeWidget(), window.Brainfish.HelpWidget.open = () => this.openWidget()), (d = window.Brainfish) !== null && d !== void 0 && d.Widgets && (window.Brainfish.Widgets.open = () => this.openWidget(), window.Brainfish.Widgets.close = () => this.closeWidget());
  }
  static toggleIframeVisibility() {
    this.isOpen = !this.isOpen, this.isOpen ? this.openWidget() : this.closeWidget();
  }
  static openWidget() {
    var t;
    this.isOpen = !0;
    const n = document.querySelector(".bf-iframe-container"), d = n == null ? void 0 : n.querySelector("iframe");
    if (n == null || n.classList.add("open"), n == null || n.setAttribute("aria-hidden", "false"), d == null || (t = d.contentWindow) === null || t === void 0 || t.postMessage({ type: "FOCUS_SEARCH_FIELD" }, "*"), this.button && this.icon) {
      const i = this.icon.querySelector(".fish-icon"), r = this.icon.querySelector(".close-icon");
      this.button.setAttribute("aria-expanded", "true"), i.classList.remove("visible"), r.classList.add("visible"), document.body.clientWidth <= 576 && this.hideTriggerButton();
    }
    window.dispatchEvent(new Event("onBrainfishWidgetOpen")), window.BrainfishAnalytics("track", "Open Widget");
  }
  static closeWidget() {
    this.isOpen = !1;
    const t = document.querySelector(".bf-iframe-container");
    if (t == null || t.classList.remove("open"), t == null || t.setAttribute("aria-hidden", "true"), this.button && this.icon) {
      this.button.setAttribute("aria-expanded", "false");
      const n = this.icon.querySelector(".fish-icon"), d = this.icon.querySelector(".close-icon");
      n.classList.add("visible"), d.classList.remove("visible"), document.body.clientWidth <= 576 && this.showTriggerButton();
    }
    window.dispatchEvent(new Event("onBrainfishWidgetClose")), window.BrainfishAnalytics("track", "Close Widget");
  }
  static showTriggerButton() {
    var t;
    (t = this.button) === null || t === void 0 || t.classList.remove("hidden");
  }
  static hideTriggerButton() {
    var t;
    (t = this.button) === null || t === void 0 || t.classList.add("hidden");
  }
}
C(y, "isOpen", !1), C(y, "button", null), C(y, "icon", null), C(y, "isButtonHidden", !1);
function Ne(a) {
  let { widgetHost: t, apiHost: n, widgetKey: d, signal: i } = a;
  window.addEventListener("message", (r) => {
    if (r.origin !== t) return;
    const { type: e } = r.data;
    if (e === "TOGGLE_WIDGET_SIZE" && function() {
      const s = document.querySelector(`.${L}`);
      s.classList.contains("expanded") ? s.classList.remove("expanded") : s.classList.add("expanded");
    }(), e === "TRACK_EVENT") {
      if (!window.BrainfishAnalytics) return;
      const { eventName: s, data: l } = r.data;
      window.BrainfishAnalytics("track", s, l);
    }
    if (e === "CLOSE_WIDGET" && (window.BrainfishAnalytics("track", "Close Widget"), y.toggleIframeVisibility()), e === "NEXT_BEST_ACTION_CLICKED") {
      const { action: s, searchQueryId: l, query: o, answer: u } = r.data, c = { action: s, searchQueryId: l };
      if (!["function", "callback"].includes(s.type)) return void console.error("Invalid action type", s);
      if (window.__bfCallbacks = window.__bfCallbacks || {}, window.__bfCallbacks[s.id]) return void window.__bfCallbacks[s.id](o, u, c);
      const f = `${n}/api/searchWidgets.callback.codeblocks?apiKey=${d}&codeblockId=${s.id}`, g = document.createElement("script");
      g.src = f, document.head.appendChild(g), g.onload = () => {
        window.__bfCallbacks[s.id](o, u, c), setTimeout(() => {
          document.head.removeChild(g);
        }, 300);
      };
    }
  }, { signal: i });
}
function ue(a) {
  return a && a.__esModule && Object.prototype.hasOwnProperty.call(a, "default") ? a.default : a;
}
var q = { exports: {} }, N = { exports: {} }, D = { exports: {} };
(function(a, t) {
  function n(i) {
    return Math.round(255 * i);
  }
  function d(i, r, e) {
    return n(i) + "," + n(r) + "," + n(e);
  }
  t.__esModule = !0, t.default = void 0, t.default = function(i, r, e, s) {
    if (s === void 0 && (s = d), r === 0) return s(e, e, e);
    var l = (i % 360 + 360) % 360 / 60, o = (1 - Math.abs(2 * e - 1)) * r, u = o * (1 - Math.abs(l % 2 - 1)), c = 0, f = 0, g = 0;
    l >= 0 && l < 1 ? (c = o, f = u) : l >= 1 && l < 2 ? (c = u, f = o) : l >= 2 && l < 3 ? (f = o, g = u) : l >= 3 && l < 4 ? (f = u, g = o) : l >= 4 && l < 5 ? (c = u, g = o) : l >= 5 && l < 6 && (c = o, g = u);
    var h = e - o / 2;
    return s(c + h, f + h, g + h);
  }, a.exports = t.default;
})(D, D.exports);
var fe = D.exports, J = { exports: {} };
(function(a, t) {
  t.__esModule = !0, t.default = void 0;
  var n = { aliceblue: "f0f8ff", antiquewhite: "faebd7", aqua: "00ffff", aquamarine: "7fffd4", azure: "f0ffff", beige: "f5f5dc", bisque: "ffe4c4", black: "000", blanchedalmond: "ffebcd", blue: "0000ff", blueviolet: "8a2be2", brown: "a52a2a", burlywood: "deb887", cadetblue: "5f9ea0", chartreuse: "7fff00", chocolate: "d2691e", coral: "ff7f50", cornflowerblue: "6495ed", cornsilk: "fff8dc", crimson: "dc143c", cyan: "00ffff", darkblue: "00008b", darkcyan: "008b8b", darkgoldenrod: "b8860b", darkgray: "a9a9a9", darkgreen: "006400", darkgrey: "a9a9a9", darkkhaki: "bdb76b", darkmagenta: "8b008b", darkolivegreen: "556b2f", darkorange: "ff8c00", darkorchid: "9932cc", darkred: "8b0000", darksalmon: "e9967a", darkseagreen: "8fbc8f", darkslateblue: "483d8b", darkslategray: "2f4f4f", darkslategrey: "2f4f4f", darkturquoise: "00ced1", darkviolet: "9400d3", deeppink: "ff1493", deepskyblue: "00bfff", dimgray: "696969", dimgrey: "696969", dodgerblue: "1e90ff", firebrick: "b22222", floralwhite: "fffaf0", forestgreen: "228b22", fuchsia: "ff00ff", gainsboro: "dcdcdc", ghostwhite: "f8f8ff", gold: "ffd700", goldenrod: "daa520", gray: "808080", green: "008000", greenyellow: "adff2f", grey: "808080", honeydew: "f0fff0", hotpink: "ff69b4", indianred: "cd5c5c", indigo: "4b0082", ivory: "fffff0", khaki: "f0e68c", lavender: "e6e6fa", lavenderblush: "fff0f5", lawngreen: "7cfc00", lemonchiffon: "fffacd", lightblue: "add8e6", lightcoral: "f08080", lightcyan: "e0ffff", lightgoldenrodyellow: "fafad2", lightgray: "d3d3d3", lightgreen: "90ee90", lightgrey: "d3d3d3", lightpink: "ffb6c1", lightsalmon: "ffa07a", lightseagreen: "20b2aa", lightskyblue: "87cefa", lightslategray: "789", lightslategrey: "789", lightsteelblue: "b0c4de", lightyellow: "ffffe0", lime: "0f0", limegreen: "32cd32", linen: "faf0e6", magenta: "f0f", maroon: "800000", mediumaquamarine: "66cdaa", mediumblue: "0000cd", mediumorchid: "ba55d3", mediumpurple: "9370db", mediumseagreen: "3cb371", mediumslateblue: "7b68ee", mediumspringgreen: "00fa9a", mediumturquoise: "48d1cc", mediumvioletred: "c71585", midnightblue: "191970", mintcream: "f5fffa", mistyrose: "ffe4e1", moccasin: "ffe4b5", navajowhite: "ffdead", navy: "000080", oldlace: "fdf5e6", olive: "808000", olivedrab: "6b8e23", orange: "ffa500", orangered: "ff4500", orchid: "da70d6", palegoldenrod: "eee8aa", palegreen: "98fb98", paleturquoise: "afeeee", palevioletred: "db7093", papayawhip: "ffefd5", peachpuff: "ffdab9", peru: "cd853f", pink: "ffc0cb", plum: "dda0dd", powderblue: "b0e0e6", purple: "800080", rebeccapurple: "639", red: "f00", rosybrown: "bc8f8f", royalblue: "4169e1", saddlebrown: "8b4513", salmon: "fa8072", sandybrown: "f4a460", seagreen: "2e8b57", seashell: "fff5ee", sienna: "a0522d", silver: "c0c0c0", skyblue: "87ceeb", slateblue: "6a5acd", slategray: "708090", slategrey: "708090", snow: "fffafa", springgreen: "00ff7f", steelblue: "4682b4", tan: "d2b48c", teal: "008080", thistle: "d8bfd8", tomato: "ff6347", turquoise: "40e0d0", violet: "ee82ee", wheat: "f5deb3", white: "fff", whitesmoke: "f5f5f5", yellow: "ff0", yellowgreen: "9acd32" };
  t.default = function(d) {
    if (typeof d != "string") return d;
    var i = d.toLowerCase();
    return n[i] ? "#" + n[i] : d;
  }, a.exports = t.default;
})(J, J.exports);
var De = J.exports, U = { exports: {} };
(function(a, t) {
  function n(l) {
    var o = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
    return n = function(u) {
      if (u === null || !function(f) {
        try {
          return Function.toString.call(f).indexOf("[native code]") !== -1;
        } catch (g) {
          return typeof f == "function";
        }
      }(u)) return u;
      if (typeof u != "function") throw new TypeError("Super expression must either be null or a function");
      if (o !== void 0) {
        if (o.has(u)) return o.get(u);
        o.set(u, c);
      }
      function c() {
        return function(f, g, h) {
          if (d()) return Reflect.construct.apply(null, arguments);
          var p = [null];
          p.push.apply(p, g);
          var m = new (f.bind.apply(f, p))();
          return h && i(m, h.prototype), m;
        }(u, arguments, r(this).constructor);
      }
      return c.prototype = Object.create(u.prototype, { constructor: { value: c, enumerable: !1, writable: !0, configurable: !0 } }), i(c, u);
    }, n(l);
  }
  function d() {
    try {
      var l = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch (o) {
    }
    return (d = function() {
      return !!l;
    })();
  }
  function i(l, o) {
    return i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(u, c) {
      return u.__proto__ = c, u;
    }, i(l, o);
  }
  function r(l) {
    return r = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    }, r(l);
  }
  t.__esModule = !0, t.default = void 0;
  var e = { 1: `Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).

`, 2: `Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).

`, 3: `Passed an incorrect argument to a color function, please pass a string representation of a color.

`, 4: `Couldn't generate valid rgb string from %s, it returned %s.

`, 5: `Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.

`, 6: `Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).

`, 7: `Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).

`, 8: `Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.

`, 9: `Please provide a number of steps to the modularScale helper.

`, 10: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`, 11: `Invalid value passed as base to modularScale, expected number or em string but got "%s"

`, 12: `Expected a string ending in "px" or a number passed as the first argument to %s(), got "%s" instead.

`, 13: `Expected a string ending in "px" or a number passed as the second argument to %s(), got "%s" instead.

`, 14: `Passed invalid pixel value ("%s") to %s(), please pass a value like "12px" or 12.

`, 15: `Passed invalid base value ("%s") to %s(), please pass a value like "12px" or 12.

`, 16: `You must provide a template to this method.

`, 17: `You passed an unsupported selector state to this method.

`, 18: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`, 19: `fromSize and toSize must be provided as stringified numbers with the same units.

`, 20: `expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`, 21: "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n", 22: "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n", 23: `fontFace expects a name of a font-family.

`, 24: `fontFace expects either the path to the font file(s) or a name of a local copy.

`, 25: `fontFace expects localFonts to be an array.

`, 26: `fontFace expects fileFormats to be an array.

`, 27: `radialGradient requries at least 2 color-stops to properly render.

`, 28: `Please supply a filename to retinaImage() as the first argument.

`, 29: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`, 30: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n", 31: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation

`, 32: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])
To pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')

`, 33: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation

`, 34: `borderRadius expects a radius value as a string or number as the second argument.

`, 35: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`, 36: `Property must be a string value.

`, 37: `Syntax Error at %s.

`, 38: `Formula contains a function that needs parentheses at %s.

`, 39: `Formula is missing closing parenthesis at %s.

`, 40: `Formula has too many closing parentheses at %s.

`, 41: `All values in a formula must have the same unit or be unitless.

`, 42: `Please provide a number of steps to the modularScale helper.

`, 43: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`, 44: `Invalid value passed as base to modularScale, expected number or em/rem string but got %s.

`, 45: `Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.

`, 46: `Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.

`, 47: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`, 48: `fromSize and toSize must be provided as stringified numbers with the same units.

`, 49: `Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`, 50: `Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.

`, 51: `Expects the first argument object to have the properties prop, fromSize, and toSize.

`, 52: `fontFace expects either the path to the font file(s) or a name of a local copy.

`, 53: `fontFace expects localFonts to be an array.

`, 54: `fontFace expects fileFormats to be an array.

`, 55: `fontFace expects a name of a font-family.

`, 56: `linearGradient requries at least 2 color-stops to properly render.

`, 57: `radialGradient requries at least 2 color-stops to properly render.

`, 58: `Please supply a filename to retinaImage() as the first argument.

`, 59: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`, 60: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n", 61: `Property must be a string value.

`, 62: `borderRadius expects a radius value as a string or number as the second argument.

`, 63: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`, 64: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.

`, 65: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').

`, 66: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.

`, 67: `You must provide a template to this method.

`, 68: `You passed an unsupported selector state to this method.

`, 69: `Expected a string ending in "px" or a number passed as the first argument to %s(), got %s instead.

`, 70: `Expected a string ending in "px" or a number passed as the second argument to %s(), got %s instead.

`, 71: `Passed invalid pixel value %s to %s(), please pass a value like "12px" or 12.

`, 72: `Passed invalid base value %s to %s(), please pass a value like "12px" or 12.

`, 73: `Please provide a valid CSS variable.

`, 74: `CSS variable not found and no default was provided.

`, 75: `important requires a valid style object, got a %s instead.

`, 76: `fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.

`, 77: `remToPx expects a value in "rem" but you provided it in "%s".

`, 78: `base must be set in "px" or "%" but you set it in "%s".
` };
  function s() {
    for (var l = arguments.length, o = new Array(l), u = 0; u < l; u++) o[u] = arguments[u];
    var c, f = o[0], g = [];
    for (c = 1; c < o.length; c += 1) g.push(o[c]);
    return g.forEach(function(h) {
      f = f.replace(/%[a-z]/, h);
    }), f;
  }
  t.default = function(l) {
    var o, u;
    function c(f) {
      var g;
      if (process.env.NODE_ENV === "production") g = l.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + f + " for more information.") || this;
      else {
        for (var h = arguments.length, p = new Array(h > 1 ? h - 1 : 0), m = 1; m < h; m++) p[m - 1] = arguments[m];
        g = l.call(this, s.apply(void 0, [e[f]].concat(p))) || this;
      }
      return function(b) {
        if (b === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return b;
      }(g);
    }
    return u = l, (o = c).prototype = Object.create(u.prototype), o.prototype.constructor = o, i(o, u), c;
  }(n(Error)), a.exports = t.default;
})(U, U.exports);
var E = U.exports;
(function(a, t) {
  t.__esModule = !0, t.default = function(h) {
    if (typeof h != "string") throw new i.default(3);
    var p = (0, d.default)(h);
    if (p.match(e)) return { red: parseInt("" + p[1] + p[2], 16), green: parseInt("" + p[3] + p[4], 16), blue: parseInt("" + p[5] + p[6], 16) };
    if (p.match(s)) {
      var m = parseFloat((parseInt("" + p[7] + p[8], 16) / 255).toFixed(2));
      return { red: parseInt("" + p[1] + p[2], 16), green: parseInt("" + p[3] + p[4], 16), blue: parseInt("" + p[5] + p[6], 16), alpha: m };
    }
    if (p.match(l)) return { red: parseInt("" + p[1] + p[1], 16), green: parseInt("" + p[2] + p[2], 16), blue: parseInt("" + p[3] + p[3], 16) };
    if (p.match(o)) {
      var b = parseFloat((parseInt("" + p[4] + p[4], 16) / 255).toFixed(2));
      return { red: parseInt("" + p[1] + p[1], 16), green: parseInt("" + p[2] + p[2], 16), blue: parseInt("" + p[3] + p[3], 16), alpha: b };
    }
    var k = u.exec(p);
    if (k) return { red: parseInt("" + k[1], 10), green: parseInt("" + k[2], 10), blue: parseInt("" + k[3], 10) };
    var w = c.exec(p.substring(0, 50));
    if (w) return { red: parseInt("" + w[1], 10), green: parseInt("" + w[2], 10), blue: parseInt("" + w[3], 10), alpha: parseFloat("" + w[4]) > 1 ? parseFloat("" + w[4]) / 100 : parseFloat("" + w[4]) };
    var I = f.exec(p);
    if (I) {
      var Ae = parseInt("" + I[1], 10), Ie = parseInt("" + I[2], 10) / 100, Oe = parseInt("" + I[3], 10) / 100, pe = "rgb(" + (0, n.default)(Ae, Ie, Oe) + ")", O = u.exec(pe);
      if (!O) throw new i.default(4, p, pe);
      return { red: parseInt("" + O[1], 10), green: parseInt("" + O[2], 10), blue: parseInt("" + O[3], 10) };
    }
    var x = g.exec(p.substring(0, 50));
    if (x) {
      var Me = parseInt("" + x[1], 10), je = parseInt("" + x[2], 10) / 100, Te = parseInt("" + x[3], 10) / 100, ge = "rgb(" + (0, n.default)(Me, je, Te) + ")", M = u.exec(ge);
      if (!M) throw new i.default(4, p, ge);
      return { red: parseInt("" + M[1], 10), green: parseInt("" + M[2], 10), blue: parseInt("" + M[3], 10), alpha: parseFloat("" + x[4]) > 1 ? parseFloat("" + x[4]) / 100 : parseFloat("" + x[4]) };
    }
    throw new i.default(5);
  };
  var n = r(fe), d = r(De), i = r(E);
  function r(h) {
    return h && h.__esModule ? h : { default: h };
  }
  var e = /^#[a-fA-F0-9]{6}$/, s = /^#[a-fA-F0-9]{8}$/, l = /^#[a-fA-F0-9]{3}$/, o = /^#[a-fA-F0-9]{4}$/, u = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i, c = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i, f = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i, g = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
  a.exports = t.default;
})(N, N.exports);
var ce = N.exports;
(function(a, t) {
  t.__esModule = !0, t.default = function(i) {
    if (i === "transparent") return 0;
    var r = (0, d.default)(i), e = Object.keys(r).map(function(u) {
      var c = r[u] / 255;
      return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    }), s = e[0], l = e[1], o = e[2];
    return parseFloat((0.2126 * s + 0.7152 * l + 0.0722 * o).toFixed(3));
  };
  var n, d = (n = ce) && n.__esModule ? n : { default: n };
  a.exports = t.default;
})(q, q.exports);
const Je = ue(q.exports);
var Y = { exports: {} }, G = { exports: {} };
(function(a, t) {
  function n(d, i, r) {
    return function() {
      var e = r.concat(Array.prototype.slice.call(arguments));
      return e.length >= i ? d.apply(this, e) : n(d, i, e);
    };
  }
  t.__esModule = !0, t.default = function(d) {
    return n(d, d.length, []);
  }, a.exports = t.default;
})(G, G.exports);
var ve, j, we = G.exports, V = { exports: {} };
ve = V, (j = V.exports).__esModule = !0, j.default = void 0, j.default = function(a, t, n) {
  return Math.max(a, Math.min(t, n));
}, ve.exports = j.default;
var xe = V.exports, Z = { exports: {} }, Q = { exports: {} };
(function(a, t) {
  t.__esModule = !0, t.default = void 0, t.default = function(n) {
    var d, i = n.red / 255, r = n.green / 255, e = n.blue / 255, s = Math.max(i, r, e), l = Math.min(i, r, e), o = (s + l) / 2;
    if (s === l) return n.alpha !== void 0 ? { hue: 0, saturation: 0, lightness: o, alpha: n.alpha } : { hue: 0, saturation: 0, lightness: o };
    var u = s - l, c = o > 0.5 ? u / (2 - s - l) : u / (s + l);
    switch (s) {
      case i:
        d = (r - e) / u + (r < e ? 6 : 0);
        break;
      case r:
        d = (e - i) / u + 2;
        break;
      default:
        d = (i - r) / u + 4;
    }
    return d *= 60, n.alpha !== void 0 ? { hue: d, saturation: c, lightness: o, alpha: n.alpha } : { hue: d, saturation: c, lightness: o };
  }, a.exports = t.default;
})(Q, Q.exports);
var Ue = Q.exports;
(function(a, t) {
  t.__esModule = !0, t.default = function(r) {
    return (0, d.default)((0, n.default)(r));
  };
  var n = i(ce), d = i(Ue);
  function i(r) {
    return r && r.__esModule ? r : { default: r };
  }
  a.exports = t.default;
})(Z, Z.exports);
var Se = Z.exports, X = { exports: {} }, ee = { exports: {} }, te = { exports: {} }, ne = { exports: {} };
(function(a, t) {
  t.__esModule = !0, t.default = void 0, t.default = function(n) {
    return n.length === 7 && n[1] === n[2] && n[3] === n[4] && n[5] === n[6] ? "#" + n[1] + n[3] + n[5] : n;
  }, a.exports = t.default;
})(ne, ne.exports);
var _e = ne.exports, re = { exports: {} };
(function(a, t) {
  t.__esModule = !0, t.default = void 0, t.default = function(n) {
    var d = n.toString(16);
    return d.length === 1 ? "0" + d : d;
  }, a.exports = t.default;
})(re, re.exports);
var ke = re.exports;
(function(a, t) {
  t.__esModule = !0, t.default = void 0;
  var n = r(fe), d = r(_e), i = r(ke);
  function r(l) {
    return l && l.__esModule ? l : { default: l };
  }
  function e(l) {
    return (0, i.default)(Math.round(255 * l));
  }
  function s(l, o, u) {
    return (0, d.default)("#" + e(l) + e(o) + e(u));
  }
  t.default = function(l, o, u) {
    return (0, n.default)(l, o, u, s);
  }, a.exports = t.default;
})(te, te.exports);
var Ce = te.exports;
(function(a, t) {
  t.__esModule = !0, t.default = function(r, e, s) {
    if (typeof r == "number" && typeof e == "number" && typeof s == "number") return (0, n.default)(r, e, s);
    if (typeof r == "object" && e === void 0 && s === void 0) return (0, n.default)(r.hue, r.saturation, r.lightness);
    throw new d.default(1);
  };
  var n = i(Ce), d = i(E);
  function i(r) {
    return r && r.__esModule ? r : { default: r };
  }
  a.exports = t.default;
})(ee, ee.exports);
var Ye = ee.exports, ae = { exports: {} };
(function(a, t) {
  t.__esModule = !0, t.default = function(e, s, l, o) {
    if (typeof e == "number" && typeof s == "number" && typeof l == "number" && typeof o == "number") return o >= 1 ? (0, n.default)(e, s, l) : "rgba(" + (0, d.default)(e, s, l) + "," + o + ")";
    if (typeof e == "object" && s === void 0 && l === void 0 && o === void 0) return e.alpha >= 1 ? (0, n.default)(e.hue, e.saturation, e.lightness) : "rgba(" + (0, d.default)(e.hue, e.saturation, e.lightness) + "," + e.alpha + ")";
    throw new i.default(2);
  };
  var n = r(Ce), d = r(fe), i = r(E);
  function r(e) {
    return e && e.__esModule ? e : { default: e };
  }
  a.exports = t.default;
})(ae, ae.exports);
var Ge = ae.exports, ie = { exports: {} };
(function(a, t) {
  t.__esModule = !0, t.default = function(e, s, l) {
    if (typeof e == "number" && typeof s == "number" && typeof l == "number") return (0, n.default)("#" + (0, d.default)(e) + (0, d.default)(s) + (0, d.default)(l));
    if (typeof e == "object" && s === void 0 && l === void 0) return (0, n.default)("#" + (0, d.default)(e.red) + (0, d.default)(e.green) + (0, d.default)(e.blue));
    throw new i.default(6);
  };
  var n = r(_e), d = r(ke), i = r(E);
  function r(e) {
    return e && e.__esModule ? e : { default: e };
  }
  a.exports = t.default;
})(ie, ie.exports);
var Ee = ie.exports, oe = { exports: {} };
(function(a, t) {
  t.__esModule = !0, t.default = function(e, s, l, o) {
    if (typeof e == "string" && typeof s == "number") {
      var u = (0, n.default)(e);
      return "rgba(" + u.red + "," + u.green + "," + u.blue + "," + s + ")";
    }
    if (typeof e == "number" && typeof s == "number" && typeof l == "number" && typeof o == "number") return o >= 1 ? (0, d.default)(e, s, l) : "rgba(" + e + "," + s + "," + l + "," + o + ")";
    if (typeof e == "object" && s === void 0 && l === void 0 && o === void 0) return e.alpha >= 1 ? (0, d.default)(e.red, e.green, e.blue) : "rgba(" + e.red + "," + e.green + "," + e.blue + "," + e.alpha + ")";
    throw new i.default(7);
  };
  var n = r(ce), d = r(Ee), i = r(E);
  function r(e) {
    return e && e.__esModule ? e : { default: e };
  }
  a.exports = t.default;
})(oe, oe.exports);
var Ve = oe.exports;
(function(a, t) {
  t.__esModule = !0, t.default = function(f) {
    if (typeof f != "object") throw new e.default(8);
    if (o(f)) return (0, r.default)(f);
    if (l(f)) return (0, i.default)(f);
    if (c(f)) return (0, d.default)(f);
    if (u(f)) return (0, n.default)(f);
    throw new e.default(8);
  };
  var n = s(Ye), d = s(Ge), i = s(Ee), r = s(Ve), e = s(E);
  function s(f) {
    return f && f.__esModule ? f : { default: f };
  }
  var l = function(f) {
    return typeof f.red == "number" && typeof f.green == "number" && typeof f.blue == "number" && (typeof f.alpha != "number" || f.alpha === void 0);
  }, o = function(f) {
    return typeof f.red == "number" && typeof f.green == "number" && typeof f.blue == "number" && typeof f.alpha == "number";
  }, u = function(f) {
    return typeof f.hue == "number" && typeof f.saturation == "number" && typeof f.lightness == "number" && (typeof f.alpha != "number" || f.alpha === void 0);
  }, c = function(f) {
    return typeof f.hue == "number" && typeof f.saturation == "number" && typeof f.lightness == "number" && typeof f.alpha == "number";
  };
  a.exports = t.default;
})(X, X.exports);
var Be = X.exports;
(function(a, t) {
  t.__esModule = !0, t.default = void 0;
  var n = e(we), d = e(xe), i = e(Se), r = e(Be);
  function e(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function s() {
    return s = Object.assign ? Object.assign.bind() : function(o) {
      for (var u = 1; u < arguments.length; u++) {
        var c = arguments[u];
        for (var f in c) Object.prototype.hasOwnProperty.call(c, f) && (o[f] = c[f]);
      }
      return o;
    }, s.apply(this, arguments);
  }
  var l = (0, n.default)(function(o, u) {
    if (u === "transparent") return u;
    var c = (0, i.default)(u);
    return (0, r.default)(s({}, c, { lightness: (0, d.default)(0, 1, c.lightness - parseFloat(o)) }));
  });
  t.default = l, a.exports = t.default;
})(Y, Y.exports);
const Ze = ue(Y.exports);
var se = { exports: {} };
(function(a, t) {
  t.__esModule = !0, t.default = void 0;
  var n = e(we), d = e(xe), i = e(Se), r = e(Be);
  function e(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function s() {
    return s = Object.assign ? Object.assign.bind() : function(o) {
      for (var u = 1; u < arguments.length; u++) {
        var c = arguments[u];
        for (var f in c) Object.prototype.hasOwnProperty.call(c, f) && (o[f] = c[f]);
      }
      return o;
    }, s.apply(this, arguments);
  }
  var l = (0, n.default)(function(o, u) {
    if (u === "transparent") return u;
    var c = (0, i.default)(u);
    return (0, r.default)(s({}, c, { lightness: (0, d.default)(0, 1, c.lightness + parseFloat(o)) }));
  });
  t.default = l, a.exports = t.default;
})(se, se.exports);
const Qe = ue(se.exports);
function Xe(a) {
  if (!document.querySelector("style[data-widget-styles]")) {
    var t, n;
    (function() {
      let d = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "#000", i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "FFF";
      const r = document.createElement("style");
      r.attributes.setNamedItem(document.createAttribute("data-widget-styles"));
      const e = Je(d) > 0.5;
      r.textContent = `
    .bf-trigger-button{position:fixed;bottom:16px;right:16px;width:36px;height:36px;border-radius:50%;border:none;box-shadow:0 1px 6px #0000000f,0 2px 32px #00000029;transition:transform 167ms cubic-bezier(.33,0,0,1);box-sizing:content-box;display:flex;align-items:center;justify-content:center;cursor:pointer;z-index:1000;padding:12px;gap:10px;overflow:hidden}.bf-trigger-button.hidden{display:none}.trigger-button-icon{display:flex;align-items:center;justify-content:center;width:36px;height:36px;position:relative}.trigger-button-icon svg{width:100%;height:100%;position:absolute;inset:0}.trigger-button-icon>svg>path{transition:transform .3s ease,opacity .3s ease;transform:scale(.5);transform-origin:center;opacity:0}.trigger-button-icon .fish-icon{display:none}.trigger-button-icon .fish-icon.visible{display:block}.trigger-button-icon svg.visible{display:block}.trigger-button-icon>svg.visible>path{opacity:1;transform:scale(1)}.trigger-iframe{position:relative;width:100%;height:100%;border:none;outline:none;transform:translateZ(0)}.bf-iframe-container{display:none;position:fixed;z-index:2147483000000;background-color:#fff;bottom:0;right:0;width:100vw;height:100vh;border:none;overflow:hidden;opacity:0;pointer-events:none;transform:translateY(20px);transition:opacity .3s ease,transform .3s ease,width .2s ease-in-out,height .2s ease-in-out}.bf-iframe-container.open{display:block;opacity:1;transform:translateY(0);pointer-events:auto;top:0;left:0}@media (min-width: 576px){.bf-iframe-container{bottom:80px;right:24px;width:448px;height:min(750px,calc(100vh - 80px));border-radius:8px;border:1px solid var(--Dark-300, #D4D4D4);box-shadow:0 20px 25px -5px #1212171a,0 10px 10px -5px #1212170a}.bf-iframe-container.open{top:unset;left:unset}.bf-iframe-container.expanded{width:min(calc(448px * 1.35),calc(100vw - 16px));height:min(calc(750px * 1.35),calc(100vh - 80px))}}.iframe-loading-indicator{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);display:flex;align-items:center;justify-content:center;z-index:10}.spinner{width:24px;height:24px;border:2px solid rgba(0,0,0,.1);border-radius:50%;border-top-color:#3498db;animation:spin 1s ease-in-out infinite}@keyframes spin{to{transform:rotate(360deg)}}.loading-error{width:24px;height:24px;position:relative;display:flex;align-items:center;justify-content:center}.loading-error:before,.loading-error:after{content:"";position:absolute;width:16px;height:2px;background-color:#e74c3c;border-radius:2px}.loading-error:before{transform:rotate(45deg)}.loading-error:after{transform:rotate(-45deg)}
    .${W} { background: ${d}; }
    .${W}:hover {
      background: ${e ? Ze(0.05, d) : Qe(0.05, d)};
    }
    .trigger-button-icon { color: ${i}; }
  `, document.head.appendChild(r);
    })((a == null || (t = a.theme) === null || t === void 0 ? void 0 : t.inputButtonBgColor) || "#007bff", (a == null || (n = a.theme) === null || n === void 0 ? void 0 : n.textBaseColor) || "#ffffff");
  }
}
function et(a, t) {
  const n = () => {
    ((d) => {
      var i;
      (i = a.contentWindow) === null || i === void 0 || i.postMessage({ type: "UPDATE_BODY_CLASS", isDarkMode: d }, "*");
    })(document.body.classList.contains("dark"));
  };
  n(), (() => {
    const d = new MutationObserver(n);
    d.observe(document.body, { attributes: !0, attributeFilter: ["class"] }), t.addEventListener("abort", () => d.disconnect());
  })();
}
function tt(a, t) {
  let n;
  const d = () => {
    ((r) => {
      var e;
      const s = { type: "UPDATE_BODY_CLASS", isMobile: r };
      (e = a.contentWindow) === null || e === void 0 || e.postMessage(s, "*"), r && (y.isWidgetOpen ? y.hideTriggerButton() : y.showTriggerButton());
    })(document.body.clientWidth <= 576);
  }, i = () => {
    n && clearTimeout(n), n = window.setTimeout(d, 300);
  };
  d(), (() => {
    const r = new ResizeObserver(i);
    r.observe(document.body), t.addEventListener("abort", () => r.disconnect());
  })();
}
function K(a) {
  const t = new TextEncoder().encode(a);
  if (typeof window != "undefined" && typeof window.btoa == "function") {
    const n = Array.from(t, (d) => String.fromCharCode(d)).join("");
    return btoa(n);
  }
  if (typeof Buffer != "undefined") return Buffer.from(t).toString("base64");
  throw new Error("[utils.base64Encode]: Unsupported environment");
}
const ye = /* @__PURE__ */ new Set();
function nt(a, t, n) {
  let { isButtonHidden: d, triggerButtonIcon: i } = n;
  const r = document.createDocumentFragment();
  if (d) y.initialize({ isButtonHidden: d });
  else {
    const { button: l, icon: o } = function(u, c) {
      const f = S("button", W, { id: `trigger-button-${u}`, "aria-controls": L, "aria-expanded": "false", "data-name": W }), g = S("div", "trigger-button-icon", { "aria-hidden": "true" });
      return g.innerHTML = c ? `
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 256 256" class="close-icon">
        <path d="M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z"></path>
      </svg>
      <img src="${c}" class="fish-icon visible" alt="Trigger button icon" height="32" width="32" aria-hidden="true" aria-label="help button icon" />
    ` : `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 256 256" class="close-icon">
      <path d="M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z"></path>
    </svg>
    <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="fish-icon visible">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M1.71844 10.3882L4.60606 6.98384L1.71844 3.58375C1.4014 3.21362 1.44424 2.65841 1.81269 2.33993C1.97978 2.1979 2.65242 1.98701 3.04657 2.43461L5.78425 5.65824C6.14281 5.29523 6.51693 4.95924 6.90479 4.65114C8.88976 3.07437 11.2345 2.22803 13.6931 2.22803C16.9492 2.22803 20.0039 3.71718 22.2917 6.41142C22.5702 6.74282 22.5702 7.22916 22.2917 7.56056C20.0039 10.2591 16.9492 11.744 13.6931 11.744C11.2348 11.744 8.89035 10.8948 6.90554 9.31995C6.51741 9.01199 6.14304 8.67628 5.78425 8.31374L3.04657 11.5374C2.72953 11.9075 2.18114 11.9505 1.81269 11.632C1.44852 11.3179 1.40568 10.7584 1.71844 10.3882ZM5.93026 10.4683C8.17161 12.2599 10.8546 13.25 13.6931 13.25C17.4881 13.25 21.019 11.4034 23.4447 8.52942C24.1873 7.64571 24.1843 6.31801 23.4397 5.43663C20.8944 2.43919 17.4337 0.722025 13.6931 0.722025C10.8555 0.722025 8.17194 1.70845 5.92952 3.50276L4.17682 1.43933C3.57943 0.760929 2.79325 0.630009 2.25286 0.662947C1.98116 0.679506 1.73125 0.736852 1.51895 0.811846C1.26839 0.900352 1.03017 1.02718 0.827835 1.20058C-0.165283 2.05903 -0.283916 3.561 0.574656 4.56345L2.63075 6.98445L0.568104 9.41623C-0.272133 10.4106 -0.166523 11.9125 0.827835 12.7714C1.81372 13.6243 3.34308 13.5062 4.19036 12.5171L5.93026 10.4683Z" fill="currentColor"/>
    </svg>
  `, f.setAttribute("aria-label", "Open Brainfish widget"), f.appendChild(g), { button: f, icon: g };
    }(a, i);
    r.appendChild(l), y.initialize({ button: l, icon: o });
  }
  const { iframeContainer: e, iframe: s } = function(l) {
    const o = S("div", L, { id: L, "aria-live": "polite", "aria-hidden": "true" }), u = S("div", "iframe-loading-indicator"), c = S("div", "spinner");
    u.setAttribute("aria-label", "Loading content"), u.setAttribute("role", "status"), u.appendChild(c), o.appendChild(u);
    const f = S("iframe", "trigger-iframe", { src: l, sandbox: "allow-scripts allow-same-origin allow-popups allow-forms", allow: "clipboard-write", role: "dialog" });
    return f.style.opacity = "0", f.addEventListener("load", () => {
      u.style.display = "none", f.style.opacity = "1";
    }), f.addEventListener("error", (g) => {
      console.error("Error loading iframe:", g), u.innerHTML = "";
      const h = S("div", "loading-error");
      u.appendChild(h), u.setAttribute("aria-label", "Failed to load content");
    }), o.appendChild(f), { iframeContainer: o, iframe: f };
  }(t);
  return r.appendChild(e), { fragment: r, iframe: s };
}
const rt = (a, t) => {
  var n;
  const d = le(a.overrides), i = ((r = a.overrides) == null ? void 0 : r.widgetHost) || "https://agent.brainfi.sh";
  var r;
  const { theme: e, settings: s } = t, l = K(JSON.stringify((n = a.overrides) === null || n === void 0 ? void 0 : n.redirectRules)), o = `${i}/?widgetKey=${a.widgetKey}#${new URLSearchParams({ theme: K(JSON.stringify(e)), settings: K(JSON.stringify(s)), redirectRules: l }).toString()}`, u = s == null ? void 0 : s.hideTriggerButton, c = s == null ? void 0 : s.triggerButtonIcon;
  try {
    if (f = a.widgetKey, ye.has(f) || function(k) {
      return !!document.getElementById(`trigger-button-${k}`);
    }(a.widgetKey)) return;
    Xe(t);
    const { fragment: g, iframe: h } = nt(a.widgetKey, o, { isButtonHidden: u || !1, triggerButtonIcon: c || "" }), p = new AbortController(), { signal: m } = p;
    h.onload = () => {
      setTimeout(() => {
        et(h, m), Ne({ widgetHost: i, apiHost: d, widgetKey: a.widgetKey, signal: m }), tt(h, m);
      }, 0);
    }, document.body.appendChild(g), ye.add(a.widgetKey);
    const b = () => {
      p.abort(), window.removeEventListener("beforeunload", b);
    };
    return void window.addEventListener("beforeunload", b);
  } catch (g) {
    (function(h, p, m) {
      _(h, p, p.message, m);
    })(d, g, a.widgetKey);
  }
  var f;
};
let T = null;
const B = typeof window != "undefined" && window.Brainfish ? window.Brainfish : (T || (T = /* @__PURE__ */ function() {
  let a = [], t = null;
  function n(i, r) {
    if (t) {
      const e = i.split(".");
      let s = t;
      for (let o = 0; o < e.length - 1; o++) s = s[e[o]];
      const l = s[e[e.length - 1]];
      if (typeof l == "function") return l.apply(s, r);
    } else a.push([i, r]);
  }
  return { Widgets: { init: function() {
    for (var i = arguments.length, r = new Array(i), e = 0; e < i; e++) r[e] = arguments[e];
    return n("Widgets.init", r);
  }, identify: function() {
    for (var i = arguments.length, r = new Array(i), e = 0; e < i; e++) r[e] = arguments[e];
    return n("Widgets.identify", r);
  }, open: () => n("Widgets.open", []), close: () => n("Widgets.close", []), isReady: !1 }, SearchWidget: { initStandard: function() {
    for (var i = arguments.length, r = new Array(i), e = 0; e < i; e++) r[e] = arguments[e];
    return n("SearchWidget.initStandard", r);
  } }, HelpWidget: { initPopup: function() {
    for (var i = arguments.length, r = new Array(i), e = 0; e < i; e++) r[e] = arguments[e];
    return n("HelpWidget.initPopup", r);
  }, close: function() {
    for (var i = arguments.length, r = new Array(i), e = 0; e < i; e++) r[e] = arguments[e];
    return n("HelpWidget.close", r);
  }, open: function() {
    for (var i = arguments.length, r = new Array(i), e = 0; e < i; e++) r[e] = arguments[e];
    return n("HelpWidget.open", r);
  }, toggle: function() {
    for (var i = arguments.length, r = new Array(i), e = 0; e < i; e++) r[e] = arguments[e];
    return n("HelpWidget.toggle", r);
  } }, _setRealBrainfish: function(i) {
    for (t = i; a.length > 0; ) {
      const [r, e] = a.shift();
      n(r, e);
    }
  } };
}(), typeof window != "undefined" && (window.Brainfish = T)), T);
let z = null;
B.Widgets.isReady = !1, B.Widgets.identify = (a) => {
  window.BrainfishAnalytics("identify", a);
}, B.Widgets.init = (a) => v(void 0, null, function* () {
  window && (window.BrainfishAnalytics = window.BrainfishAnalytics || function() {
    for (var r = arguments.length, e = new Array(r), s = 0; s < r; s++) e[s] = arguments[s];
    (window.BrainfishAnalytics.q = window.BrainfishAnalytics.q || []).push(e);
  });
  const t = le(a.overrides), n = ((d = a.overrides) == null ? void 0 : d.analyticsApiHost) || "";
  var d;
  let i;
  if (a.config) i = JSON.parse(((r) => {
    if (typeof window != "undefined" && typeof window.atob == "function") {
      const e = atob(r), s = e.length, l = new Uint8Array(s);
      for (let o = 0; o < s; o++) l[o] = e.charCodeAt(o);
      return new TextDecoder().decode(l);
    }
    if (typeof Buffer != "undefined") return Buffer.from(r, "base64").toString("utf-8");
    throw new Error("[utils.base64Decode]: Unsupported environment");
  })(a.config));
  else {
    const { config: r } = yield $e({ widgetKey: a.widgetKey, apiHost: t });
    i = r;
  }
  z || (z = function(r, e, s, l) {
    return v(this, null, function* () {
      var o, u, c, f, g;
      const h = ((o = r.overrides) === null || o === void 0 ? void 0 : o.enableRecording) || (e == null || (u = e.settings) === null || u === void 0 ? void 0 : u.enableRecording) || !1, p = ((c = r.overrides) === null || c === void 0 ? void 0 : c.version) || (e == null ? void 0 : e.version), m = [];
      p != null && p.startsWith("2.") ? rt(r, e) : m.push(Re(r, e)), m.push(qe(r.widgetKey, e.trackingToken || "", s, l, h, (e == null || (f = e.settings) === null || f === void 0 ? void 0 : f.recordingBlocklist) || [], e == null || (g = e.settings) === null || g === void 0 ? void 0 : g._allowLocalhostRecording));
      const [b] = yield Promise.allSettled(m);
      b && b.status === "fulfilled" && b.value && B._setRealBrainfish(b.value);
    });
  }(a, i, t, n)), yield z, B.Widgets.isReady = !0, window.dispatchEvent(new Event("onBrainfishReady"));
});
const it = function() {
  typeof window != "undefined" && window.BrainfishAnalytics && window.BrainfishAnalytics(...arguments);
};
export {
  it as BrainfishAnalytics,
  B as default
};
//# sourceMappingURL=web.js.map
